export const fnHandleChangeText = (form, setForm) => (e) => {
    const name = e.target.name;
    const value = e.target.value;

    setForm({
        ...form,
        [name]: {
            ...form[name],
            value: value,
            error: value === "",
        },
    });
};

export const fnHandleChangeTextNotError = (form, setForm) => (e) => {
    const name = e.target.name;
    const value = e.target.value;

    setForm({
        ...form,
        [name]: {
            ...form[name],
            value: value,
            error: false,
        },
    });
};

export const fnHandleChangeTextUpper = (form, setForm) => (e) => {
    const name = e.target.name;
    const value = e.target.value;

    setForm({
        ...form,
        [name]: {
            ...form[name],
            value: value,
            // value: typeof value === "string" ? value.toUpperCase() : value,
            error: value === "",
        },
    });
};

export const fnHandleChangeDate = (form, setForm) => (date, name) => {
    setForm({
        ...form,
        [name]: {
            ...form[name],
            value: date,
            error: !date,
        },
    });
};

export const fnHandleChangeChek = (form, setForm) => (e, name) => {
    setForm({
        ...form,
        [name]: {
            ...form[name],
            value: e.target.checked,
            error: false,
        },
    });
};

export const fnHandleChangeInteger = (form, setForm) => (e) => {
    const name = e.target.name;
    const value = e.target.value;

    if (value !== "" && value !== "-" && value !== "0" && value % 1 !== 0) {
        return;
    }

    setForm({
        ...form,
        [name]: {
            ...form[name],
            value: value,
            error: value === "",
        },
    });
};

export const fnHandleChangeUInteger = (form, setForm) => (e) => {
    const name = e.target.name;
    const value = e.target.value;

    if (value !== "" && value !== "0" && value % 1 !== 0) {
        return;
    }

    setForm({
        ...form,
        [name]: {
            ...form[name],
            value: value,
            error: value === "",
        },
    });
};

export const fnHandleChangeDecimal = (form, setForm) => (e) => {
    const name = e.target.name;
    const value = e.target.value;

    if (isNaN(value) && value !== "" && value !== "-") {
        return;
    }

    setForm({
        ...form,
        [name]: {
            ...form[name],
            value: value,
            error: value === "",
        },
    });
};

export const fnHandleChangeUDecimal = (form, setForm) => (e) => {
    const name = e.target.name;
    const value = e.target.value;

    if (isNaN(value) && value !== "") {
        return;
    }

    setForm({
        ...form,
        [name]: {
            ...form[name],
            value: value,
            error: value === "",
        },
    });
};

export const fnHandleChangeAutoComplete = (form, setForm) => (name) => (e, value) => {
    setForm({
        ...form,
        [name]: {
            ...form[name],
            value,
            error: !value,
        },
    });
};
